import { assign, createMemberDecorator } from '@rehaje/shared'

import { annotations, deep } from './annotations'
import { FatalDecoratorNotSupportError } from './errors'

import type {
  AnnotationLike,
  AnyAnnotation,
  ExtractAnnotationOption,
  ReactiveFn
} from './types'

const decorator = createMemberDecorator<
  [AnnotationLike, ExtractAnnotationOption<AnnotationLike>],
  [AnyAnnotation, ExtractAnnotationOption<AnnotationLike>]
>({
  argsProcess(reactive = 'ref', options) {
    reactive = typeof reactive === 'string' ? annotations[reactive] : reactive
    return typeof reactive === 'function'
      ? [reactive as AnyAnnotation, options]
      : undefined
  },
  esAccessorDecorator(arg1, context, reactive, options) {
    if (reactive._esAccessorDecorator === undefined)
      throw new FatalDecoratorNotSupportError(reactive._name, context.name)
    return reactive._esAccessorDecorator(context, options)
  },
  esGetterDecorator(arg1, context, reactive, options) {
    if (reactive._esGetterDecorator === undefined)
      throw new FatalDecoratorNotSupportError(reactive._name, context.name)
    return reactive._esGetterDecorator(arg1, context, options)
  },
  esMethodDecorator(arg1, context, reactive, options) {
    if (reactive._esMethodDecorator === undefined)
      throw new FatalDecoratorNotSupportError(reactive._name, context.name)
    return reactive._esMethodDecorator(arg1, context, options)
  },
  tsDecorator(proto, key, descriptor, reactive, options) {
    if (reactive._tsDecorator === undefined)
      throw new FatalDecoratorNotSupportError(reactive._name, key)
    return reactive._tsDecorator(proto, key, descriptor, options)
  }
})

function mixture(arg1?: any, arg2?: any) {
  if (typeof arg1 === 'string' || arg1 === undefined)
    return decorator(arg1, arg2)
  if (typeof arg1 === 'object' && arg1 !== null) return deep(arg1, arg2)
}

export const reactive: ReactiveFn = assign(mixture, annotations)
